import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BASE_URL } from '@elevate-workspace/auth';
import { Observable } from 'rxjs';
import { cartResponse } from '../../../shared/interface/cart';

@Injectable({
  providedIn: 'root'
})
export class CartService {


_httpClient = inject(HttpClient);
_bASE_URL=inject(BASE_URL)



getCartData():Observable<cartResponse>{
  return this._httpClient.get<cartResponse>(this._bASE_URL+'api/v1/cart');
 
}
addToCartData(productId:string,quantity:number):Observable<cartResponse>{
  return this._httpClient.post<cartResponse>(this._bASE_URL+'api/v1/cart',{ product: productId,quantity});
}

UpdateCartData(productId:string,quantity:number):Observable<cartResponse>{
  return this._httpClient.put<cartResponse>(this._bASE_URL+`api/v1/cart/${productId}`,{quantity});
}

removeFromCartData(productId:string):Observable<cartResponse>{
  return this._httpClient.delete<cartResponse>(this._bASE_URL+`api/v1/cart/${productId}`);

}

clearCartData(): Observable<cartResponse> {
  return this._httpClient.delete<cartResponse>(this._bASE_URL + 'api/v1/cart');
}


applyCouponData(couponCode: string): Observable<cartResponse> {
  return this._httpClient.post<cartResponse>(this._bASE_URL + 'api/v1/cart/apply-coupon', { couponCode });

}
validateCartData(couponCode:string): Observable<any> {
  return this._httpClient.post<any>(this._bASE_URL + 'api/v1/cart/validate', { couponCode });

}

}
